import { render } from "./AddService.vue?vue&type=template&id=00cc2a1a&scoped=true"
import script from "./AddService.vue?vue&type=script&lang=js"
export * from "./AddService.vue?vue&type=script&lang=js"

import "./AddService.vue?vue&type=style&index=0&id=00cc2a1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00cc2a1a"]])

export default __exports__